export default __webpack_public_path__ + "static/media/globe.6cb2bacf.jpg";